import * as React from "react";

 function NotFound () {
    return (
        <h1 style={{justifyContent: "center", display: "flex"}}>404: Page not found</h1>
    );
};

export default NotFound;